import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import { addAnimations } from '../Animations';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class NumberBox extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, position, number)
    {
        super(scene);

        this.number = null;
        this.position = null;
        this.chest = null;
        this.bodyDef = null;
        this.fixture = null;
        this.lid = null;
        this.suffix = null;
        this.parentObject = null;

        this.isFilled = false;

        this.parentObject = scene;

        this.number = number;
        this.position = position;
        this.suffix = null;

        let sheet = null;

        switch (this.position)
        {
            case 1:
            case 2:
                sheet = "chest-1-2";
                break;
            case 3:
            case 4:
                sheet = "chest-3-4";
                break;
            case 5:
                sheet = "chest-5";
                break;
            case 6:
                sheet = "chest-6";
                break;
            case 7:
            case 8:
                sheet = "chest-7-8";
                break;
            case 9:
            case 10:
                sheet = "chest-9-10";
                break;
        }

        //create static shark
        this.sharkAnimation = this.scene.add.sprite(0, 0, "sharkBite", "0");

        this.chestAnimation = this.scene.add.sprite(0, 0, sheet, "0");
        addAnimations(this.chestAnimation, sheet);
        this.add(this.chestAnimation);

        this.createBodyDef();

        this.on(Phaser.GameObjects.Events.ADDED_TO_SCENE, () => this.adjustShark());

        this.sharkIsEating = false;
    }

    // Original Createjs game centered the container origin, which isn't possible in Phaser, this fixes it
    centerContainer()
    {
        this.chestAnimation.x -= this.chestAnimation.width / 2;
        this.chestAnimation.y -= this.chestAnimation.height / 2;
    }

    createBodyDef()
    {
        let fixture = new Box2D.Dynamics.b2FixtureDef;
        fixture.density = 1;
        fixture.restitution = 0.6;
        fixture.shape = new Box2D.Collision.Shapes.b2PolygonShape.AsBox(30, 30);

        this.fixture = fixture;

        let bodyDef = new Box2D.Dynamics.b2BodyDef;
        bodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;

        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this);
        bodyDef.position.x = globalPt.x / SCALE;
        bodyDef.position.y = globalPt.y / SCALE;

        this.bodyDef = bodyDef;
    }

    adjustShark()
    {
        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this.chestAnimation);

        this.sharkAnimation.x = globalPt.x + 30;
        this.sharkAnimation.y = globalPt.y + 42;

        this.parentObject.children.moveTo(this.sharkAnimation, 1);
    }

    getHalfBoundsRect()
    {
        let xAdj = 0;
        let widthAdj = 0;
        switch (this.position)
        {
            case 1:
                xAdj = -10;
                widthAdj = 10;
                break;
            case 2:
                xAdj = -5;
                break;
            case 3:
                xAdj = -5;
                break;
            case 4:
                xAdj = 5;
                break;
            case 5:
                xAdj = 10;
                widthAdj = 5;
                break;
            case 6:
            case 7:
                xAdj = 5;
                break;
        }
        let rect = new Phaser.Geom.Rectangle(this.x - this.chestAnimation.width / 6 - 4 + xAdj, this.y, this.chestAnimation.width / 4 + 16 + widthAdj, this.chestAnimation.height / 4);
        return rect;
    }

    correct()
    {
        this.isFilled = true;

        this.animateClosing(this.number, 0xffffff);
    }

    animateClosing(number, color)
    {
        this.chestAnimation.play("Shut");

        this.scene.time.delayedCall(1200, this.showNumberColor, [number, color], this);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._chest, this.scene, 1, false, 0.4);
    }

    showNumberColor(number, color)
    {
        let adjustX = 0;

        switch (this.position) {
            case 1:
                adjustX = -10;
                break;
            case 2:
                adjustX = -10;
                break;
            case 3:
                adjustX = -5;
                break;
            case 4:
                adjustX = -5;
                break;
            case 5:
                adjustX = -5;
                break;
            case 6:
                adjustX = 10;
                break;
            case 7:
                adjustX = 10;
                break;
            case 8:
                adjustX = 15;
                break;
            case 9:
                adjustX = 15;
                break;
            case 10:
                adjustX = 15;
                break;
        }

        this.textLabel1 = ABCyaPhaser.Text.addText(0,0, 38, color, FontKeys._odin_roundedregular, number, this.scene, true).setOrigin(0.5);
        this.textLabel1.x = -50 + adjustX;
        this.textLabel1.y = 12;
        this.add(this.textLabel1);
        this.textLabel1.alpha = 0;

        ABCyaPhaser.Tweens.addTween(this.textLabel1, 500, {alpha: 1}, Phaser.Math.Easing.Linear);
    }

    incorrect(number)
    {
        this.animateShark(number, 0xffffff);
    }

    animateShark(number, color)
    {
        if(this.sharkIsEating) return;

        this.sharkIsEating = true;
        this.sharkAnimation.play("Bite");
        this.scene.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.sharkAnimation, 300, { delay: 10, y: this.sharkAnimation.y - 100 }, Phaser.Math.Easing.Linear, () => this.putNumberInSharkMouth(number, color)),
                    ABCyaPhaser.Tweens.createTween(this.sharkAnimation, 800, { delay: 1000, y: this.sharkAnimation.y }, Phaser.Math.Easing.Linear, () => this.sharkAnimation.stop().setFrame("0")),
                ],
                onComplete: ()=> this.sharkIsEating = false
        });
    }

    putNumberInSharkMouth(number, color)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._shark, this.scene);

        this.sharkText = ABCyaPhaser.Text.addText(80 - this.chestAnimation.width / 2, -this.chestAnimation.height / 2, 26, color, FontKeys._odin_roundedregular, number, this).setOrigin(0.5);
        ABCyaPhaser.Tweens.addTween(this.sharkText, 1000, { scale: 0.2 }, Phaser.Math.Easing.Linear, () => this.sharkText.destroy());
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;